/*
 * @Author: panweikang
 * @Date: 2025-02-19 15:52:22
 * @LastEditTime: 2025-03-09 12:21:21
 * @Description: 
 */

import React, { Component, useEffect, useState, useMemo } from "react";
import './index.scss'
import { connect } from 'react-redux';
import MTabBar from '../../../../../components/MTabBar';


import MHead from "../../../../../components/MHead";
import { CACHE_ACCESS_TOKEN, CACHE_SESSION_USER } from "../../../../../constants/Profile";
import SearchResultItem from "../Zone/List/SearchResultItem";
import { favoriteListApi } from "../../../WebService";
import { Spin } from "antd";
import HttpUtils from "../../../../../utils/HttpUtils";

const Collect = ({ dispatch, router }) => {

  const token = localStorage.getItem(CACHE_ACCESS_TOKEN)
  const user = JSON.parse(localStorage.getItem(CACHE_SESSION_USER))

  useEffect(() => {
    token && getList()
  }, [token])

  const [loading, setLoading] = useState(false)

  const [list, setList] = useState([])
  const getList = () => {
    setLoading(true)
    HttpUtils.post(
      favoriteListApi,
      null,
      (res) => {
        setList(res.data.list)
        setLoading(false)
      }, () => {
        setLoading(false)
      }
    )

  }

  return (
    <>
      {
        <div className="tabbarBottom collect">
          <MHead isBack={true} router={router} />
          <Spin spinning={loading}>
            <div className="CollectList">
              {
                list.map((zone, index) => {
                  return (
                    <SearchResultItem
                      showCollect={true}
                      key={index}
                      zone={zone}
                      router={router}
                      refreshList={getList} />
                  )
                })
              }
            </div>
          </Spin>
        </div>
      }
      <MTabBar router={router} index={3} />
    </>

  );
};


function mapStateToProps(store) {
  return {};
}


export default connect(mapStateToProps)(Collect)
